export default function ProductSpecifications({

    productSpecifications = [],

    variationSpecifications = []

}) {

    const rows = [

        ...productSpecifications,

        ...variationSpecifications,

    ].filter(item => item.value);

    return (

        <div className="specifications">

            {rows.map((row, index) => (

                <div

                    className="specification-value"

                    key={index}

                >

                    <div>{row.name}</div>

                    <div
                        dangerouslySetInnerHTML={{
                            __html: row.value
                        }}
                    />

                </div>

            ))}

        </div>

    )

}